// extracted by mini-css-extract-plugin
export default {"next-slide-btn":"NextBtn_next-slide-btn__XFZIG","next-slide-btn__icon":"NextBtn_next-slide-btn__icon__RBqEQ"};